import keyMirror from 'key-mirror';
import { createActions } from 'redux-actions';

export const constants = keyMirror({
    GET_DASHBOARD_STATS_REQUEST: null,
    GET_DASHBOARD_STATS_SUCCESS: null,
    GET_DASHBOARD_STATS_FAILURE: null,
});

export const {
    getDashboardStatsRequest,
    getDashboardStatsSuccess,
    getDashboardStatsFailure
} = createActions(
    constants.GET_DASHBOARD_STATS_REQUEST,
    constants.GET_DASHBOARD_STATS_SUCCESS,
    constants.GET_DASHBOARD_STATS_FAILURE
);
